/**
 * Menu items roles.
 * @public
 */
export const MenuItemRoles = {
    /**
     * The menu item has a "menuitem" role
     */
    menuitem: "menuitem",
    /**
     * The menu item has a "menuitemcheckbox" role
     */
    menuitemcheckbox: "menuitemcheckbox",
    /**
     * The menu item has a "menuitemradio" role
     */
    menuitemradio: "menuitemradio"
};
/**
 * @internal
 */
export const roleForMenuItem = {
    [MenuItemRoles.menuitem]: "menuitem",
    [MenuItemRoles.menuitemcheckbox]: "menuitemcheckbox",
    [MenuItemRoles.menuitemradio]: "menuitemradio"
};
/**
 * Menu items roles.
 * @public
 */
export const MenuGroupRoles = {
    /**
     * The "group" role
     */
    group: "group"
};
/**
 * @internal
 */
export const roleForMenuGroup = {
    group: MenuGroupRoles.group
};
//# sourceMappingURL=menu-item.options.js.map